import React, { useEffect, useState } from "react";

// Animated mini bar chart. data: [{ label, value }].
export default function MiniBars({ data = [], height = 64 }) {
  const [grow, setGrow] = useState(0);
  useEffect(() => {
    const id = requestAnimationFrame(() => setGrow(1));
    return () => cancelAnimationFrame(id);
  }, [data]);

  const max = Math.max(1, ...data.map((d) => d.value || 0));

  return (
    <div className="minibars" style={{ height: height + 18 }}>
      {data.map((d, i) => {
        const h = ((d.value || 0) / max) * height * grow;
        return (
          <div className="mb-col" key={i}>
            <div className="mb-track" style={{ height }}>
              <div
                className={`mb-bar ${d.value > 0 ? "" : "empty"}`}
                style={{ height: Math.max(3, h), transitionDelay: `${i * 50}ms` }}
              />
            </div>
            <span className="mb-label">{d.label}</span>
          </div>
        );
      })}
    </div>
  );
}
